import _ from 'lodash';
import {
  INITIALIZE_VALUES,
  INCREMENT_VALUE_LAYER,
  DECREMENT_VALUE_LAYER,
  INCREMENT_DISPLAY_LAYER,
  DECREMENT_DISPLAY_LAYER,
} from '../actions/valueSet';

const initialState = {
  values: {},
  randomizedIds: [],
  displayLayer: 0,
};

function shuffleArray(array) {
  let i = array.length - 1;
  for (; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

export function valueSet(state = initialState, action) {
  switch (action.type) {
    case INITIALIZE_VALUES: {
      const randomizedIdList = [];

      const newValueSet = _.reduce(action.valueArray,
        (newSet, obj) => {
          randomizedIdList.push(obj.id);

          const newObj = Object.assign({}, obj);
          const newObjSet = Object.assign({}, newSet);

          newObj.layer = 0;
          newObjSet[newObj.id] = newObj;
          return newObjSet;
        }, {});

      shuffleArray(randomizedIdList);

      const valueState = {
        values: newValueSet,
        randomizedIds: randomizedIdList,
        displayLayer: 0,
      };

      return Object.assign({}, state, valueState);
    }
    case INCREMENT_VALUE_LAYER: {
      const newObj = Object.assign({}, state.values[action.valueId]);
      newObj.layer += 1;

      const newValues = Object.assign({}, state.values);
      newValues[newObj.id] = newObj;

      return Object.assign({}, state, { values: newValues });
    }
    case DECREMENT_VALUE_LAYER: {
      // We are not actually going to decrement here - instead we are just going
      // to set the layer to the current display layer - 1. This is so we don't have to
      // click multiple times when going back multiple layers.
      const newObj = Object.assign({}, state.values[action.valueId]);
      newObj.layer = state.displayLayer;

      const newValues = Object.assign({}, state.values);
      newValues[newObj.id] = newObj;

      return Object.assign({}, state, { values: newValues });
    }
    case INCREMENT_DISPLAY_LAYER: {
      const newDisplayLayer = state.displayLayer + 1;
      console.log(`Setting New Display Layer to ${newDisplayLayer}`);
      return Object.assign({}, state, { displayLayer: newDisplayLayer });
    }
    case DECREMENT_DISPLAY_LAYER: {
      const newDisplayLayer = state.displayLayer - 1;
      console.log(`Setting New Display Layer to ${newDisplayLayer}`);
      return Object.assign({}, state, { displayLayer: newDisplayLayer });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/valueSet.js